import React from "react";
import { Formik, Field, Form } from "formik";
import { Form as SemForm } from "semantic-ui-react";
import "./login.css";
import MainButton from "../../components/Buttons/MainButton";

const errorStyle = {
	marginBottom: 10,
	color: "#dc0000",
	fontSize: 12,
};

const CustomInputTextComponent = ({ field, form: { touched, errors }, ...props }) => (
	<div>
		<SemForm.Input
			{...field}
			{...props}
			fluid
			icon="mail"
			iconPosition="left"
			placeholder="Adresse email ou identifiant"
			style={{ marginBottom: 10 }}
		/>
		{touched[field.name] && errors[field.name] && <div style={errorStyle}>{errors[field.name]}</div>}
	</div>
);

const ForgotPassword = ({ submitEmail }) => {
	return (
		<div>
			<Formik initialValues={{ email: "" }} onSubmit={(value) => submitEmail(value)}>
				{({ isSubmitting }) => (
					<Form>
						<Field customlabel="Email" name="email" required component={CustomInputTextComponent} className="login__input" />
						<MainButton text="Réinitialiser" type="submit" style={{ width: "100%" }} />
					</Form>
				)}
			</Formik>
		</div>
	);
};

export default ForgotPassword;
